import { useMutation, useQuery } from 'react-query'
import { quizzes } from '../../Repositories/Quiz/Quiz'

/**
 * this function is to Query get All application
 * @function useQuizTypeGetQueryById
 ** @param {reqId, options} default parameter
 */
/**
export function useQuizInfoGetQueryById(reqId, options) {
  return useQuery(
    ['quizTypeGetQueryById', reqId],
    () => quizzes().getQuizInfoById(reqId),
    { ...options }
  )
}
 */

/**
 * this function is to Query get All application
 * @function useQuizGetQueryById
 ** @param {reqId, options} default parameter
 */
export function useQuizGetQueryById(reqId, options) {
  return useQuery(
    ['quizGetQueryById', reqId],
    () => quizzes().getQuizById(reqId),
    { ...options }
  )
}

/**
 * this function is to Query get All application
 * @function useQuizQuestionGetQueryById
 ** @param {reqId, options} default parameter
 */
export function useQuizQuestionGetQueryById(reqId, options) {
  return useQuery(
    ['quizQuestionGetQueryById', reqId],
    () => quizzes().getQuizQuestionById(reqId),
    { ...options }
  )
}

/**
 * this function is to get user specific evaluated response
 * @function useQuizGetQueryEvaluatedResponseById
 ** @param {reqId, options} default parameter
 */
export function useQuizGetQueryEvaluatedResponseById(reqId, options) {
  return useQuery(
    ['quizGetQueryEvaluatedResponseById', reqId],
    () => quizzes().getQueryEvaluatedResponseById(reqId),
    { ...options }
  )
}

/**
 * this function is to Query get All application
 * @function useQuizResponsePutQueryById
 ** @param {reqId, options} default parameter
 */
export function useQuizResponsePutQueryById(reqId, options) {
  return useMutation(() => quizzes().putQuizResponseById(reqId), {
    ...options,
  })
}

/**
 * this function is to Query get All application
 * @function useQuizPostQueryById
 ** @param {reqId, options} default parameter
 */
export function useQuizPostQueryById(reqId, options) {
  return useMutation(() => quizzes().postQuizById(reqId), {
    ...options,
  })
}

/**
 * this function is to Query get All application
 * @function useMCQPutQueryById
 ** @param {reqId, options} default parameter
 */
export function useMCQPostQueryById(reqQuestionId, options) {
  return useMutation((args) => quizzes().postMCQById(reqQuestionId, args), {
    ...options,
  })
}

/**
 * this function is to Query get All application
 * @function useCodingQuestionPutQueryById
 ** @param {reqId, options} default parameter
 */
export function useCodingQuestionPostQueryById(reqQuizId, options) {
  return useMutation(
    (args) => quizzes().postCodingQuestionById(reqQuizId, args),
    {
      ...options,
    }
  )
}

/**
 * this function is to Query get All application
 * @function useQuestionSubmissionGetById
 ** @param {reqId, options} default parameter
 */
/** 
 export function useQuestionSubmissionGetQueryById(
  reqId,
  reqQuestionId,
  reqUserIdentifier,
  options
) {
  return useQuery(
    ['questionGetById', reqId, reqQuestionId, reqUserIdentifier],
    () =>
      quizzes().getQuestionSubmisisonById(
        reqId,
        reqQuestionId,
        reqUserIdentifier
      ),
    { ...options }
  )
}
*/

/**
 * this function is to Query get All application
 * @function useTabChangePatchQuery
 ** @param {reqId, options} default parameter
 */
export function useTabChangePatchQuery(reqQuizId, reqResponseId, options) {
  return useMutation(
    (args) => quizzes().patchTabChange(reqQuizId, reqResponseId, args),
    {
      ...options,
    }
  )
}
